const systemMessage = {
    namespaced: true,
    state: () => ({
        ModalMessage: "",
    }),
    getters: {
        getModalMessage: (state) => {
            return state.ModalMessage;
        }
    },
    actions: {
        setModalMessage({ commit }, params) {
            commit("SET_MODAL_MESSAGE", params.message)
        }
    },
    mutations: {
        SET_MODAL_MESSAGE: (state, message) => {
            state.ModalMessage = message ? message : "";
        }
    }
}

export default systemMessage;

